import { Box, Checkbox, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ModalHeader from '../../common/Header'
import '../../../styles/Reports/UserCollectionReport.scss'
import DropDown from '../../common/DropDown'
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import CustomDatePicker from '../../common/CustomDatePicker'
import MButton from '../../common/MButton'
import dayjs from 'dayjs'
import CustomRadio from '../../common/CustomRadio'
import { useDispatch, useSelector } from 'react-redux'
import { getQuickView, getUserWiseCollSummary } from '../../../redux/Report/ReportActions'
import { getBranchList, getBranchUserList, getCityList, updateShowAlert } from '../../../redux/Actions'
import { groupByMultiKey, isEmpty } from '../../../Utils'
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import UserCollectionDetails from './UserCollectionDetails'

const UserCollectionReport = () => {
    const { cityList, userDetails, branchList, branchUserList } = useSelector((state) => state.common);
    const dispatch = useDispatch()
    const [filterValue, setFilterValue] = useState({
        user: [],
        branch: [],
        todate: dayjs(new Date()),
        fromDate: dayjs(new Date()),
        isJourneyDate: 1,
    })
    const [filterOpt, setFilterOpt] = useState({
        user: []
    })
    const [showReport, setShowReport] = useState(false)
    const [reportDate, setReportData] = useState([])

    useEffect(() => {
        if (!isEmpty(userDetails)) {
            const bodyBranch = {
                intBranchID: 0,
                strBranchCode: '',
                strBranchName: '',
                intStateID: 0,
                intCityID: 0,
                intIsActive: 1,
                intUserID: userDetails?.UserID,
                intCompanyID: userDetails?.CompanyID,
            };
            const bodyBranchUser = {
                intUserID: 0,
                intBranchID: 0,
                strUserName: '',
                strLoginID: '',
                strPassword: '',
                strContactNo: '',
                intRoleID: 0,
                intIsActive: 1,
                intCompanyID: userDetails?.CompanyID,
            };
            dispatch(getBranchList(bodyBranch))
            dispatch(getBranchUserList(bodyBranchUser))
        }
    }, [userDetails?.CompanyID])



    useEffect(() => {
        if (!isEmpty(userDetails)) {
            let defBranch = branchList.filter((obj) => obj.BranchID === userDetails?.BranchID)
            let userList = []
            let defUser = []
            if (defBranch?.length !== 0) {
                userList = branchUserList?.filter((obj) => obj.BranchID === defBranch?.[0]?.BranchID)
                defUser = userList?.filter((obj) => obj.UserID === userDetails?.UserID)
            }
            setFilterValue((prev) => ({
                ...prev,
                user: defUser?.length > 0 ? [defUser[0]] : [],
                branch: defBranch?.length > 0 ? [defBranch[0]] : [],
            }))
            setFilterOpt((prev) => ({
                ...prev,
                user: userList
            }))
        }

    }, [branchList, branchUserList, userDetails])
    const handleGenerate = () => {
        setShowReport(false)
        if (filterValue?.user?.length === 0) {
            dispatch(updateShowAlert({
                msg: 'Select User!',
                open: true,
            }));
        } else if (filterValue?.Branch?.length === 0) {
            dispatch(updateShowAlert({
                msg: 'Select Branch!',
                open: true,
            }));
        } else {
            const body = {
                intUserID: filterValue?.user?.[0]?.UserID || 0,
                intBranchID: filterValue?.branch?.[0]?.BranchID || 0,
                intCompanyID: userDetails?.CompanyID,
                dtFromDate: dayjs(filterValue?.fromDate).format("YYYY-MM-DD"),
                dtToDate: dayjs(filterValue?.todate).format("YYYY-MM-DD"),
                intMode: 0,
                intCityID: 0,

            }
            dispatch(getUserWiseCollSummary(body)).then((res) => {
                let data = res?.data.APIMavenBookingsUserWiseCollSummaryResult
                if (data.IsSuccess) {
                    let groupData = groupByMultiKey(JSON.parse(data.Data)?.Table, ['BranchID'])
                    let newData = []
                    Object.keys(groupData).forEach((key) => {
                        const updateData = groupedData(groupData[key]);
                        newData = [...newData, ...updateData]
                    })
                    setReportData(newData)
                    setShowReport(true)
                } else {
                    dispatch(updateShowAlert({
                        msg: data?.ErrorMessage,
                        open: true,
                    }));
                }
            })
        }
    }
    const groupedData = (arr) => {
        return [{ BranchName: arr?.[0]?.BranchName, subData: arr }]

    }
    const handleBranch = (val) => {
        let userOpt = branchUserList
        if (val?.[0].BranchID !== 0) {
            userOpt = branchUserList?.filter((obj) => obj.BranchID === val?.[0]?.BranchID)
        }
        setFilterValue((prev) => ({
            ...prev,
            branch: val,
            user: []
        }))

        setFilterOpt((prev) => ({
            ...prev,
            user: userOpt
        }))
    }
    return (
        <Box className='userCollectionpage'>
            {!showReport ?
                <>
                    <ModalHeader headerText={"User Collection"} showHamburger={true} />
                    <Box className='filter-section'>
                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>From Date</Typography>
                            </Box>
                            <Box className='datePicker'>
                                <CustomDatePicker
                                    minDate={null}
                                    selectedDate={filterValue?.fromDate}
                                    format='DD-MMM-YYYY'
                                    onChange={(val) => {
                                        if (new Date(val) < new Date(filterValue?.todate)) {
                                            setFilterValue((prev) => ({
                                                ...prev,
                                                fromDate: val
                                            }))
                                        } else {
                                            setFilterValue((prev) => ({
                                                ...prev,
                                                fromDate: val,
                                                todate: val
                                            }))
                                        }
                                    }}

                                    style={{ width: '100%' }}

                                />
                            </Box>
                        </Box>
                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>To Date</Typography>
                            </Box>
                            <Box className='datePicker'>
                                <CustomDatePicker
                                    minDate={filterValue?.fromDate}
                                    selectedDate={filterValue?.todate}
                                    format='DD-MMM-YYYY'
                                    onChange={(val) => {
                                        setFilterValue((prev) => ({
                                            ...prev,
                                            todate: val
                                        }))
                                    }}

                                    style={{ width: '100%' }}

                                />
                            </Box>
                        </Box>

                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>Branch</Typography>
                            </Box>
                            <Box className='dropDownFilter'>
                                <DropDown label='Select Branch / All Branch'
                                    showTopLable={false}
                                    headerLabel='Select Branch'
                                    StartIcon={true}
                                    Icon={PeopleIcon}
                                    option={[{ BranchID: 0, BranchName: "All Branch" }, ...branchList] || []}
                                    primaryKey='BranchID'
                                    labelKey='BranchName'
                                    preSelectedValues={filterValue?.branch || []}
                                    onSelect={handleBranch}
                                />
                            </Box>
                        </Box>


                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>User</Typography>
                            </Box>
                            <Box className='dropDownFilter'>
                                <DropDown label='Select User / All User'
                                    showTopLable={false}
                                    headerLabel='Select User'
                                    StartIcon={true}
                                    Icon={PersonIcon}
                                    option={[{ UserID: 0, UserName: "All User" }, ...filterOpt?.user] || []}
                                    primaryKey='UserID'
                                    labelKey='UserName'
                                    preSelectedValues={filterValue?.user || []}
                                    onSelect={(val) => {
                                        setFilterValue((prev) => ({
                                            ...prev,
                                            user: val
                                        }))
                                    }}
                                />
                            </Box>
                        </Box>

                        <MButton btnName="Generate" onClick={handleGenerate} />
                    </Box>
                </>
                : <UserCollectionDetails reportDate={(reportDate?.length > 0 ? [...reportDate, { isTotalRow: true }] : [])} handleBack={() => {
                    setShowReport(false)
                    setReportData([])
                }} />
            }
        </Box>
    )
}

export default UserCollectionReport